import React, { Component } from 'react';
import BookTable from "../restaurant/booktable"
import $ from "jquery";
import book from "../images/icons/book.png"
export default class HeaderBookTable extends Component {
    bookTableClick() {
        let userId = localStorage.getItem('userId');
        if (userId != null) {
            $(".bookTableSection").show();
        }
        else {
            $(".bookTableSection").hide();
            $(".loginPopUp").show();
        }
    }
    render() {
        let themeId = localStorage.getItem('themeId')
        return (
            window.sessionStorage.getItem('bookATable') === '1' ?
                <div className="headerIcons" >
                    <span className="headerImage" >
                        {themeId === '' || themeId === 'null' || themeId === null ?
                            <img src={book} title="Book A Table" onClick={this.bookTableClick} alt="" />
                            : <span className="bookTableBtn" onClick={this.bookTableClick}>Book a table</span>
                        }
                        <div class="popupWrap bookTableSection">
                            <BookTable></BookTable>
                        </div>
                    </span>
                </div>
                : ''
        )
    }
}